import React, { FunctionComponent } from 'react'
import { Trans, useTranslation } from 'next-i18next'
import { useCheckoutSizes } from '../../../utils/responsive'
import { Text } from '@afterpaytouch/core'
import styles from './style.module.css'
import { TermLink } from '../../TermLink'
import { TransProps } from 'react-i18next'

export const Terms: FunctionComponent = () => {
  const { t } = useTranslation()
  const { extraSmallTextSize } = useCheckoutSizes()

  const getTranslation = (): TransProps<string> => {
    const consentUrl = `${t('consumerLending:termsOfServiceUrl')}#e-sign`
    const creditReportUrl = `${t('consumerLending:termsOfServiceUrl')}#credit-check`
    const components = {
      creditReportAuthorization: <TermLink key='payment-types-pbi-rejected-credit-report' color='Orca' href={creditReportUrl} />,
      eSignConsent: <TermLink key='payment-types-pbi-rejected-esign-consent' color='Orca' href={consentUrl} />,
      apPrivacyPolicy: <TermLink key='payment-types-pbi-rejected-ap-privacy-policy' color='Orca' href={t('common:privacyPolicyUrl')} />,
      fePrivacyPolicy: <TermLink key='payment-types-pbi-rejected-fe-privacy-policy' color='Orca' href={t('consumerLending:febPrivacyPolicyUrl')} />,
      termsOfService: <TermLink key='payment-types-pbi-rejected-terms-of-service' color='Orca' href={t('consumerLending:termsOfServiceUrl')} />,
    }

    return { i18nKey: 'consumerLending:paymentTypesB:terms', components }
  }

  return (
    <div className={styles.PBIRejectedTermsWrapper}>
      <Text color='Gray40' size={extraSmallTextSize}>
        <Trans {...getTranslation()} />
      </Text>
    </div>
  )
}
